import React, { useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import axios from "../../../axios-instance";
import { getAdminBusinessId } from "../../../utils/authHelper";
import { startCalendarOAuth } from "../../../utils/calendarOAuth";
import { notification } from "../../../utils/utility";

/**
 * Shown when OAuth detects the chosen calendar is already linked to a staff profile.
 */
const StaffCalendarReuseModal = ({
  isOpen,
  pending,
  provider,
  onConfirmed,
  onClose,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const chooseDifferentAccount = async () => {
    setSubmitting(true);
    try {
      await startCalendarOAuth({
        businessId: getAdminBusinessId(),
        provider: provider === "outlook" ? "outlook" : "google",
        owner: "admin",
        selectAccount: true,
      });
    } finally {
      setSubmitting(false);
    }
  };

  const continueWithAccount = () => {
    if (!pending) {
      return notification.error("Missing confirmation token. Please connect again.");
    }
    setSubmitting(true);
    axios
      .post("/admin/calendar-connect-confirm", { pending })
      .then((res) => {
        notification.success(
          res?.data?.data?.message ||
            res?.data?.message ||
            "Calendar connected successfully."
        );
        if (onConfirmed) onConfirmed();
      })
      .catch((err) => {
        const msg =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          "Could not confirm calendar connection.";
        notification.error(msg);
      })
      .finally(() => setSubmitting(false));
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered>
      <ModalBody>
        <div className="rd_modalvieew">
          <div className="box_content rd_modalboxcontent">
            <div className="rd_inputselectheadermodalsetting">
              <button
                type="button"
                className="rd_colsebtn"
                onClick={onClose}
              />
            </div>
            <h5 className="rd_modalheadertext rd_modalheadertextnm">
              This calendar is already connected to your staff profile
            </h5>
            <p className="rd_modalheadertextparath mt-4 mb-4">
              Using the same calendar for your admin and staff profiles may
              affect your availability, conflict detection, and events
              associated with the organization. You can connect a different
              calendar account or continue with this one.
            </p>
            <div className="rd_cancelappbtnmodal">
              <button
                type="button"
                className="rd_cancel"
                onClick={chooseDifferentAccount}
                disabled={submitting}
              >
                Choose a different account
              </button>
              <button
                type="button"
                className="btn btn-app"
                onClick={continueWithAccount}
                disabled={submitting}
              >
                {submitting ? "Connecting…" : "Continue with this account"}
              </button>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default StaffCalendarReuseModal;
